import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonWithIcon } from '@blueprint/ui';

export const MapContainer = styled('div')(
    ({ theme }) => css`
        position: relative;
        width: 100%;
        padding-top: 50%;
        cursor: pointer;

        ${theme.mq.large} {
            padding-top: 31.25%;
        }

        ${theme.mq.extraLarge} {
            padding-top: 35.35%;
        }
    `
);

export const ExpandButton = styled(ButtonWithIcon)(({ theme }) => {
    return css`
        position: absolute;
        width: auto;
        height: auto;
        top: ${theme.spacing['16px']};
        right: ${theme.spacing['16px']};
        background: ${theme.colors.white};
        border: none;
        opacity: 0.8;
        padding: 0;

        width: auto;
        min-width: 0;

        ${theme.mq.medium} {
            right: ${theme.spacing['32px']};
        }

        & > svg {
            margin: 0;
        }

        &:hover:not(:active) {
            opacity: 1;
        }
    `;
});

export const MapInner = styled('div')(css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
    }
`);
